import {
  MarketActionCard,
  MarketRow,
  MarketAccessory,
  MarketContentCard,
} from '@market/react';
import ChevronDown from '@square-icons/react/24/UI/chevron-down';
import { SelectOption } from 'typescript/components/select_and_reveal/types';
import {
  CARD_HEIGHT,
  CARD_GAP,
} from 'typescript/components/select_and_reveal/shared_styles';
import styles from 'typescript/components/select_and_reveal/select_option_card.module.scss';

export const SELECT_OPTION_CARD_TEST_ID = 'select-option-card-test-id';
export const TRAILING_ACCESSORY_TEST_ID = 'trailing-accessory-test-id';

interface SelectOptionCardProps {
  card: SelectOption;
  index: number;
  className?: string;
  handleCardClick?: (index: number) => void;
  displayDropdownWhenCollapsed?: boolean;
  disabled?: boolean;
  cardType?: 'action' | 'content';
}

const ActionCardWrapper = ({ children, props }) => (
  <MarketActionCard {...props}>{children}</MarketActionCard>
);

const ContentCardWrapper = ({ children, props }) => (
  <MarketContentCard {...props}>{children}</MarketContentCard>
);

const SelectOptionCard = ({
  card,
  index,
  className,
  handleCardClick,
  displayDropdownWhenCollapsed,
  disabled = false,
  cardType = 'action',
}: SelectOptionCardProps) => {
  const props = {
    disabled,
    'data-testid': `${SELECT_OPTION_CARD_TEST_ID}-${index}`,
    className: `${className} ${cardType === 'content' && styles.contentCard}`,
    // inline styling necessary here to pass some logic to the scss module
    style: {
      '--translateValue': `-${CARD_HEIGHT + CARD_GAP * index}px`,
    },
    ...(handleCardClick && { onClick: () => handleCardClick(index) }),
  };

  const children = (
    <MarketRow
      transient
      interactive={false}
      className={cardType === 'content' ? styles.rowOverride : ''}
    >
      {card.icon && (
        <MarketAccessory className={styles.icon} slot="leading-accessory">
          {card.icon}
        </MarketAccessory>
      )}
      <label slot="label">
        <div className={`${styles.optionTitle} ${styles.noHighlight}`}>
          {card.title}
        </div>
        <div className={`${styles.optionSubtext} ${styles.noHighlight}`}>
          {card.subtext}
        </div>
      </label>
      {card.sideLabel && <label slot="side-label">{card.sideLabel}</label>}
      {displayDropdownWhenCollapsed && (
        <MarketAccessory slot="trailing-accessory">
          <ChevronDown data-testid={TRAILING_ACCESSORY_TEST_ID} />
        </MarketAccessory>
      )}
    </MarketRow>
  );

  return cardType === 'action' ? (
    <ActionCardWrapper props={props}>{children}</ActionCardWrapper>
  ) : (
    <ContentCardWrapper props={props}>{children}</ContentCardWrapper>
  );
};

export default SelectOptionCard;
